import { SignaturePicturePriorityEnum } from "@/utils/enums/signature.picture.priority.enum";
import InfoModal from "@components/core/modals/InfoModal";
import SignatureNoPicture from "@components/core/subComponents/signature/SignatureNoPicture";
import { t } from "i18next";
import { FunctionComponent, ReactNode } from "react";

interface PictureDefaultProps {
  i18nType: string;
  i18nModalLoadValue: string;
  i18nModalAbsenceValue: string;
  children: ReactNode;
  priority?: SignaturePicturePriorityEnum;
  handleSetDefault: (
    defaultSignature: SignaturePicturePriorityEnum,
    rank?: number,
    callback?: () => void,
  ) => void;
}

const PictureDefault: FunctionComponent<PictureDefaultProps> = ({
  i18nType,
  i18nModalLoadValue,
  i18nModalAbsenceValue,
  children,
  priority,
  handleSetDefault,
}) => {
  return (
    <div>
      <div className="grid-container-2col">
        <div>
          <div className="mb-24">
            {t(`offices.preferences.${i18nType}.load`)}
            <InfoModal value={i18nModalLoadValue} info />
          </div>
        </div>
        <div>{children}</div>

        <div>
          <div className="mb-24">
            {t(`offices.preferences.${i18nType}.noVisibleSignature.title`)}
            <InfoModal value={i18nModalAbsenceValue} info />
          </div>
        </div>
        <div>
          <SignatureNoPicture
            isDefault={priority === SignaturePicturePriorityEnum.NO_PICTURE}
            onSetDefaultPicture={handleSetDefault}
            row
          />
        </div>
      </div>
    </div>
  );
};

export default PictureDefault;
